/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_All_Errors_OptionInputs */



/**
* | output |
* | --- |
* | "All Errors" |
*
* @param {Error_Nav_All_Errors_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_all_errors_option = /** @type {((inputs?: Error_Nav_All_Errors_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_All_Errors_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les erreurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Fehler")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti gli errori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все ошибки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los errores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有错误")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのエラー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी त्रुटियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Todos os erros")
	return /** @type {LocalizedString} */ ("All Errors")
});